/*
 * Auditoría UX v25 · Textos del banner de cookies de Shopify (el diseño está en assets/ux-cookies.css).
 * La API no deja cambiar el texto del banner, así que se cambia aquí al aparecer: título, mensaje, enlace y los tres
 * botones. Solo se tocan textos; los botones, el enlace a la política y el consentimiento siguen siendo los de Shopify.
 * Si Shopify cambia el banner y no encuentra los elementos, se queda con su texto.
 */
(function () {
  'use strict';

  var TEXT = {
    title: 'Tu privacidad',
    body: 'Usamos cookies propias y de terceros para que la tienda funcione. Si aceptas, también para medir las visitas y mostrarte publicidad de nuestros productos. ',
    link: 'Más información',
    decline: 'Rechazar',
    accept: 'Aceptar',
    manage: 'Configurar'
  };

  function setText(node, text) { if (node && node.textContent !== text) node.textContent = text; }

  function apply() {
    var banner = document.getElementById('shopify-pc__banner');
    if (!banner || banner.getAttribute('data-ux-cookies') === '1') return;
    var body = banner.querySelector('.shopify-pc__banner__body');
    var p = body && body.querySelector('p');
    var link = p && p.querySelector('a');
    if (!p || !link) return;
    var title = document.createElement('p');
    title.className = 'ux-cookies__title';
    title.textContent = TEXT.title;
    body.insertBefore(title, p);
    while (p.firstChild && p.firstChild !== link) p.removeChild(p.firstChild);
    p.insertBefore(document.createTextNode(TEXT.body), link);
    setText(link, TEXT.link);
    setText(document.getElementById('shopify-pc__banner__btn-decline'), TEXT.decline);
    setText(document.getElementById('shopify-pc__banner__btn-accept'), TEXT.accept);
    var manage = document.getElementById('shopify-pc__banner__btn-manage-prefs');
    setText(manage && (manage.querySelector('span') || manage), TEXT.manage);
    banner.setAttribute('aria-label', TEXT.title);
    banner.setAttribute('data-ux-cookies', '1');
  }

  apply();
  // El banner llega después de cargar la página (lo añade el script de Shopify directamente en <body>)
  if (window.MutationObserver && document.body) {
    new MutationObserver(apply).observe(document.body, { childList: true });
  }
})();
